import React from "react";

const TrustedCustomers = () => {
  return (
    <>
      <section className="wrapper bg-light">
        <div className="container pt-md-4 pb-md-4">
          <div>
            <h2 className="fs-15 text-uppercase text-muted text-center mb-8">
              Trusted by Over 50+ Universities
            </h2>
            <div className="px-lg-5 mb-14 mb-md-19">
              <div className="row gx-0 gx-md-8 gx-xl-12 gy-8 align-items-center">
                <div className="col-4 col-md-2">
                  <figure className="px-5 px-md-0 px-lg-2 px-xl-3 px-xxl-4">
                    <img src="./assets/img/brands/c1.png" alt="" />
                  </figure>
                </div>
                <div className="col-4 col-md-2">
                  <figure className="px-5 px-md-0 px-lg-2 px-xl-3 px-xxl-4">
                    <img src="./assets/img/brands/c2.png" alt="" />
                  </figure>
                </div>
                <div className="col-4 col-md-2">
                  <figure className="px-5 px-md-0 px-lg-2 px-xl-3 px-xxl-4">
                    <img src="./assets/img/brands/c3.png" alt="" />
                  </figure>
                </div>
                <div className="col-4 col-md-2">
                  <figure className="px-5 px-md-0 px-lg-2 px-xl-3 px-xxl-4">
                    <img src="./assets/img/brands/c4.png" alt="" />
                  </figure>
                </div>
                <div className="col-4 col-md-2">
                  <figure className="px-5 px-md-0 px-lg-2 px-xl-3 px-xxl-4">
                    <img src="./assets/img/brands/c5.png" alt="" />
                  </figure>
                </div>
                <div className="col-4 col-md-2">
                  <figure className="px-5 px-md-0 px-lg-2 px-xl-3 px-xxl-4">
                    <img src="./assets/img/brands/c6.png" alt="" />
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TrustedCustomers;
